import { Box, Card, CardContent, Stack, Switch, Typography } from '@mui/material';
import { useState } from 'react';
import { getSettings, saveSettings } from '../storage/settingsStorage';

function SettingsScreen() {
  const [settings, setSettings] = useState(() => getSettings());

  const updateSetting = (key) => (event) => {
    setSettings(saveSettings({ ...settings, [key]: event.target.checked }));
  };

  return (
    <Box className="screen">
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Box>
          <Typography variant="overline" color="text.secondary">
            Saved locally
          </Typography>
          <Typography variant="h2">Settings</Typography>
        </Box>

        <Card>
          <CardContent>
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Box>
                <Typography fontWeight={800}>Autoplay video</Typography>
                <Typography color="text.secondary">Start video rounds automatically when the source allows it.</Typography>
              </Box>
              <Switch checked={settings.autoplayVideo} onChange={updateSetting('autoplayVideo')} />
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
}

export default SettingsScreen;
